import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Zahlungsmethode',
    [BillingMode.InternalInvoicing]: 'Auszahlungen',
  },
};
